<template>
  <el-dialog :close-on-click-modal="false" :title="formTitle" :visible.sync="dialogFormVisible" width="40%">
    <el-form :model="ruleForm" ref="form" label-width="120px" status-icon>
      <div style="display:flex;align-items: center;margin-bottom: 10px;margin-bottom:20px">
        <div style="width: 4px;height:20px;background-color: #409EFF;margin-right:5px"></div>
        <span style="font-size: 16px">基本信息</span>
      </div>
      <template v-if="userInfo.department_id == 0 && userInfo.town_id == 0">
        <el-form-item label="名称：" prop="nick_name">
          {{ userInfo.nick_name }}
        </el-form-item>
        <el-form-item><span style="margin-left:-50px">管理员账号</span></el-form-item>
      </template>
      <el-form-item label="名称：" prop="nick_name" v-if="userInfo.department_id != 0">
        {{ userInfo.department ? userInfo.department.name ? userInfo.department.name : '' : '' }}
      </el-form-item>
      <el-form-item label="部门：" prop="tree_name" v-if="userInfo.department_id != 0">
        {{ userInfo.department ? userInfo.department.tree_name : '' }}
      </el-form-item>
      <el-form-item label="监管对象：" prop="control_name" v-if="userInfo.department_id != 0">
        {{ userInfo.department ? userInfo.department.control_name : '' }}
      </el-form-item>
      <el-form-item label="乡镇：" prop="name" v-if="userInfo.town_id != 0">
        {{ userInfo.town ? userInfo.town.name ? userInfo.town.name : '' : '' }}
      </el-form-item>
      <el-form-item label="监管对象：" prop="name" v-if="userInfo.town_id">
        <span>全部行业企业</span>
      </el-form-item>
      <div style="display:flex;align-items: center;margin-bottom: 10px;margin-bottom:20px">
        <div style="width: 4px;height:20px;background-color: #409EFF;margin-right:5px"></div>
        <span style="font-size: 16px">联系信息</span>
      </div>
      <el-form-item label="联系姓名" prop="contact_name">
        <label slot="label">联系姓名：</label>
        <el-input  v-model="ruleForm.contact_name"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contact">
        <label slot="label">联系电话：</label>
        <el-input  v-model="ruleForm.contact"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button  @click="dialogFormVisible = false">取 消</el-button>
      <el-button  type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {api} from '@/api/api'
  import {industryOptions} from '@/Util/commonOptions'
  export default {
    data () {
      return {
        userInfo: {},
        classify_list: [],
        dialogFormVisible: false,
        industryOptions,
        departmentOptions: [],
        controlArr: [],
        departmentData: [],
        ruleForm: {
          contact_name: null, // 联系姓名
          contact:null,//联系电话
          id:null,
        },
      }
    },
    computed: {
      formTitle () {
        return '账号信息'
      }
    },
    mounted () {
      let userInfo = this.$store.getters.userInfo
      this.userInfo = userInfo
      this.ruleForm = {
        contact_name: this.userInfo.contact_name,
        contact: this.userInfo.contact,
        id: this.userInfo.id
      }
    },
    methods: {
      showForm () {
        this.dialogFormVisible = true
      },
      submitForm() {
        let params = {
          id: this.ruleForm.id,
          contact_name: this.ruleForm.contact_name,
          contact: this.ruleForm.contact
        }
        this.$http.post(api[`addOrUpdateManager`], params).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.dialogFormVisible = false
            this.$emit('refreshTable')
          } else {
            this.$message({
              message: params.id ? `修改失败 ${res.data.msg}` : `新增失败 ${res.data.msg}`,
              type: 'success'
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/frame/InfoForm.vue